import {React, useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { getTokenPayload } from "../utils/auth";

const Banner = ({loggedIn}) => { 
  const token = localStorage.getItem('token');
  const [username, setUsername] = useState("");
  const navigate = useNavigate();
  const helpUrl = `${process.env.PUBLIC_URL || ""}/hjalp`;

  // Fetch user information from localstorage
  useEffect(() => {
    if (!token) {
      return
    };

    setUsername(getTokenPayload()?.name || "Inloggad");
  }, [token]);

  return (
    <header className="relative overflow-hidden bg-gradient-to-r from-sky-700 via-sky-600 to-cyan-500 text-white shadow-md">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(255,255,255,0.24),_transparent_38%),radial-gradient(circle_at_bottom_right,_rgba(255,255,255,0.18),_transparent_32%)]" />
      <div className="app-shell relative flex items-center justify-between gap-2 px-2 py-2 sm:gap-4 sm:px-6 sm:py-4">
        <button
          className="rounded-2xl bg-white/12 px-2 py-2 backdrop-blur-sm transition-colors hover:bg-white/18 sm:px-4 sm:py-3"
          onClick={() => navigate("/mypage")}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/logo_vast.png`}
            alt="Vast Gym"
            width="120"
            height="48"
            className="h-auto w-20 sm:w-[120px]"
          />
        </button>
        {loggedIn ? (
          <div className="flex min-w-0 items-center gap-2 sm:gap-3">
            <div className="min-w-0 max-w-[44vw] rounded-2xl border border-white/20 bg-white/12 px-3 py-2 text-right shadow-sm backdrop-blur-sm sm:max-w-[55vw] sm:px-4 sm:py-3">
              <p className="hidden text-xs font-semibold uppercase tracking-[0.18em] text-sky-100 sm:block">
                Inloggad som
              </p>
              <p className="mt-1 truncate text-sm font-semibold text-white sm:text-base">
                {username}
              </p>
            </div>
            <a
              data-guide="help-link"
              href={helpUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex min-h-[44px] items-center justify-center rounded-2xl border border-white/20 bg-white/12 px-3 py-2 text-sm font-semibold text-white shadow-sm backdrop-blur-sm transition-colors hover:bg-white/18 sm:h-[72px] sm:px-4 sm:py-3"
              aria-label="Öppna hjälp"
              title="Öppna hjälp"
            >
              Hjälp
            </a>
          </div>
        ) : (
          <div className="h-[72px]" />
        )}
      </div>
      <div className="relative h-4 rounded-t-[28px] bg-white/20" />
    </header>
)};

export default Banner;
